import React, { useEffect, useRef } from 'react';
import './hero.scss';

interface MagneticLinkI{
    type: string;
}

const MagneticLink: React.FC<MagneticLinkI> = ({type}) => {
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = divRef.current;

        if (!el) return;

        const options = {
            ease: 0.1,
            magneticForce: 0.15
        };

        const mouse = {
            x: 0,
            y: 0
        };

        const pos = {
            cx: 0,
            cy: 0,
            tx: 0,
            ty: 0,
            x: 0,
            y: 0
        };

        let sizes = el.getBoundingClientRect();

        function observe() {
            window.addEventListener('resize', resizeHandler, false);
            el?.addEventListener('mousemove', mouseMoveHandler, false);
            el?.addEventListener('mouseleave', mouseLeaveHandler, false);
        }

        function resizeHandler() {
            sizes = el!!.getBoundingClientRect();
        }

        function mouseMoveHandler(e: MouseEvent) {
            mouse.x = e.pageX;
            mouse.y = e.pageY;

            pos.cx = sizes.left + (sizes.width / 2);
            pos.cy = sizes.top + (sizes.height / 2);

            const distX = (mouse.x - sizes.left) - (sizes.width / 2);
            const distY = (mouse.y - sizes.top) - (sizes.height / 2);

            pos.tx = distX - (distX * (1 - options.magneticForce));
            pos.ty = distY - (distY * (1 - options.magneticForce));
        }

        function mouseLeaveHandler() {
            pos.tx = 0;
            pos.ty = 0;
        }

        function render() {
            pos.x += (pos.tx - pos.x) * options.ease;
            pos.y += (pos.ty - pos.y) * options.ease;

            const transform = `translateX(${pos.x}px) translateY(${pos.y}px)`;
            el!!.style.transform = transform;
        }

        function update() {
            render();
            window.requestAnimationFrame(update);
        }

        let intervalId = setInterval(() => {
            sizes = el.getBoundingClientRect(); // Ricalcola le dimensioni
            observe();
            update();
        }, 100);

        setTimeout(() => {
            clearInterval(intervalId);  
        }, 5000);

        return () => {
            window.removeEventListener('resize', resizeHandler, false);
            el.removeEventListener('mousemove', mouseMoveHandler, false);
            el.removeEventListener('mouseleave', mouseLeaveHandler, false);
        };
    }, []);

    return <>
      <div className={"magnetic-link-wrapper " + type} ref={divRef}>
        {type === "blue" && (
            <div className="bubble blue">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                <path d="M7.79327 1.30201C8.14201 0.497769 9.28316 0.499537 9.62941 1.30485L16.6266 17.5789C16.9103 18.2389 16.4263 18.9739 15.7079 18.9739H1.65373C0.933978 18.9739 0.449931 18.2364 0.736277 17.5761L7.79327 1.30201Z" fill="#3A87F7"/>
                </svg>
                <div>Interfaces & Graphics</div>
            </div>
        )}
        {type === "orange" && (
            <div className="bubble orange">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                <path d="M7.79327 1.30201C8.14201 0.497769 9.28316 0.499537 9.62941 1.30485L16.6266 17.5789C16.9103 18.2389 16.4263 18.9739 15.7079 18.9739H1.65373C0.933978 18.9739 0.449931 18.2364 0.736277 17.5761L7.79327 1.30201Z" fill="#EA6635"/>
                </svg>
                <div>Prototyping</div>
            </div>
        )}
        {type === "purple" && (
            <div className="bubble purple">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                <path d="M7.79327 1.30201C8.14201 0.497769 9.28316 0.499537 9.62941 1.30485L16.6266 17.5789C16.9103 18.2389 16.4263 18.9739 15.7079 18.9739H1.65373C0.933978 18.9739 0.449931 18.2364 0.736277 17.5761L7.79327 1.30201Z" fill="#861AF5"/>
                </svg>
                <div>User Experience</div>
            </div>
        )}
      </div>
    </>;
};

export default MagneticLink;
